import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { exchangeCode, setStoredToken } from '../api/auth';
import Spinner from '../components/common/Spinner';

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { refresh } = useAuth();

  useEffect(() => {
    const code = searchParams.get('code');
    const returnUrl = searchParams.get('return_url') || '/';

    if (code) {
      exchangeCode(code)
        .then(({ access_token }) => {
          setStoredToken(access_token);
          return refresh();
        })
        .then(() => {
          navigate(returnUrl, { replace: true });
        })
        .catch(() => {
          navigate('/', { replace: true });
        });
    } else {
      navigate('/', { replace: true });
    }
  }, [navigate, refresh, searchParams]);

  return (
    <div className="flex flex-col items-center justify-center min-h-[50vh] gap-4">
      <Spinner size="lg" />
      <p className="text-gray-500">ログイン処理中...</p>
    </div>
  );
}
